import { useEffect } from "react";
import { useLanguage } from "@/contexts/LanguageContext";
import { useLocation } from "react-router-dom";

const PageTitleUpdater = () => {
  const { t, language } = useLanguage();
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    let titleKey = "pageTitle.main";

    if (path.includes("/games/") && path.includes("/guess/")) {
      titleKey = "pageTitle.guess";
    } else if (path.includes("/games/") && path.includes("/user-results/")) {
      titleKey = "pageTitle.results";
    } else if (path.includes("/games/")) {
      titleKey = "pageTitle.game";
    } else if (path.includes("/profile")) {
      titleKey = "pageTitle.profile";
    } else if (path.includes("/admin")) {
      titleKey = "pageTitle.admin";
    }

    const title = t(titleKey);
    // console.log("PageTitleUpdater:", { path, titleKey, title, language });
    
    if (title && !title.startsWith("pageTitle.")) {
      document.title = title;
    }
  }, [location.pathname, t, language]);

  return null;
};

export default PageTitleUpdater;
